import { get, post, del } from '@/utils/http';
import { API_FORM_TEMPLATE_GET_FORM_DATA_AUTH_LIST, API_FORM_MODEL_LIST_BY_MAIN_FORMID, API_FORM_TEMPLATE_LIST_BY_MAIN_FORMID, API_GET_FORMULA_SEARCHLIST, API_CUSTOM_MSG_CONFIG_SAVE, API_CUSTOM_MSG_CONFIG_GET, API_FORM_CALCULATION_SAVE, API_FORM_TEMPLATE_LIST, API_FORM_TEMPLATE_DETAIL, API_FORM_TEMPLATE_SAVE, API_FORM_TEMPLATE_DELETE,
    API_FORM_TEMPLATE_FORMCONFIGS, API_FORM_FORMFIELDS, API_FORM_SELECT_OPTION_SAVE, API_FORM_SELECT_OPTION_LIST_SAVE, API_FORM_SUBFORM_SUMMARY_SAVE, API_FORM_TEMPLATE_AGGREGATE_TABLE_CONFIG, API_FORM_GET_COPY_TREE_CONFIG,
    API_FORM_TEMPLATE_DETAIL_HISTORY, API_FORM_TEMPLATE_REVERT_CUSTOMFORM, API_FORM_TEMPLATE_BI_FORMCONFIGS, API_FORM_FIELD_STATISTICSGROUP, API_FORMS_LIST_BY_FIELD_TYPE, API_MODEL_FORM_LEFT_TREE,
    API_FORM_TEMPLATE_BI_DATA, API_FORM_GETDATAPROGRESSBARLIST, API_FORM_GETPROGRESSBARLIST, API_FORM_TEMPLATE_BI_CONFIG, API_FORM_APPROVE_CONFIG, API_FORM_CROSS_TEMPLATE_LIST,
    API_CUSTOM_GETFORMENTRY, API_CUSTOM_ADDFORMENTRY, API_FORM_TEMPLATE_WAREHOUSING, API_FORM_FIELD_STATISTICS, API_FORM_UPDATEUSERFORMVIEWFIELD, API_FORM_TEMPLATE_GETFORMDATALINKCONFIG, API_FORM_TEMPLATE_GET_CUSTOMFORMRULECONFIG,
    API_PROCESS_CUSTOM_FORMDATA_MAPING_LIST, API_PROCESS_CUSTOM_FORMDATA_MAPING_SAVE, API_PROCESS_CUSTOM_FORMDATA_SYNC, API_CUSTOM_MSG_CONFIG_DELETE, API_FORM_UP_MONEY_FIELD_LIST, API_FORM_CASCADE_DEPT_ROOT_ID, API_FORM_FIELD_LIST_BY_FIELDID, API_FORM_FIELD_LIST_BY_MAIN_FORM_FIELDID, API_FORM_FIELD_LIST_MAP_BY_MAIN_FORM_FIELDIDS, API_FORM_MODEL_LIST_BY_REF_FORMIDS} from '@/common/constants';

export const getFormAllConfig = (params) => {
    // http://39.107.229.85:13888/bcbpm/getFormList?currentPage=1&pageSize=10

    return get(API_FORM_TEMPLATE_LIST, Object.assign({}, {
        currentPage: 1,
        pageSize: 10
    }, params));
};

// const tempFormData = `{"id":"77f769547c5c427c920fbbe83ba0d6bf","formName":"测试环境11111","description":"1111","fieldsList":[{"id":"03e0344f995f4c9ba6557b6255cdf1c6","type":"select","name":"下拉1","icon":"&#xe654;","formField":"select_77f769547c5c427c920fbbe83ba0d6bf","options":{"id":"05ef670d15a2495fbd93ed7832b65656","config":{"id":"4cc729bcccc7443dbcc5e6e8215d9100","type":"single","options":[{"id":"1b9ebc15e79d404081ce5eef455d0c99","title":"选项1","value":"8465CE03","def":false},{"id":"5cc04b8c00f14736806f014ca189236f","title":"选项3","value":"1EF2624B","def":false},{"id":"fb74602382c54a81aeb73f336ac4a41b","title":"选项2","value":"B2690435","def":false}],"fieldOptionId":"05ef670d15a2495fbd93ed7832b65656"},"description":"","required":false,"unique":false}},{"id":"581C6EFA67F6AE03","type":"link","name":"关联数据","icon":"&#xe654;","formField":"link_581C6EFA67F6AE03","options":{"config":{"type":"link","options":[],"formId":"8f99fadfd4ff4802b02832912db574a1", "modelId": "67ef68e4187747fd8e86c99d902e162d", "formFields":"a930bd8636cb446d9e5f2d51f1b24bdc,9d38491c326f492da19d57d1b666d025,5206a28499114063b25826364a9e0eb6"},"defaultValue":"选择数据","description":"","required":false,"unique":false}},{"id":"a14856e5fadc43d182dffe54ea30d459","type":"text","name":"文本","icon":"&#xe654;","formField":"text_77f769547c5c427c920fbbe83ba0d6bf","options":{"id":"3c235f50c94c4db2a74ee07cac249e2a","config":{"id":"6d92052444dd40b6b39b3834ca1cf518","type":"input","options":[],"fieldOptionId":"3c235f50c94c4db2a74ee07cac249e2a"},"defaultValue":"","description":"","required":false,"unique":false}}]}`;
// const tempFormData = `{"id":"77f769547c5c427c920fbbe83ba0d6bf","formName":"测试环境11111","description":"1111","fieldsList":[{"id":"36E79AC31AC60D56","type":"link","name":"关联数据","icon":"&#xe654;","formField":"link_36E79AC31AC60D56","options":{"config":{"type":"link","options":[],"form":{"formId":"547adae9dfcf449f93a8b7227415a47d","modelId":"67ef68e4187747fd8e86c99d902e162d","selectFormFields":"d5afcbc5b70041d9b967fb7183786c3a,3aaefd65b1af4a1490e421bcf327b570"}},"defaultValue":"选择数据","description":"","required":false,"unique":false}},{"id":"8DAA445228DA1119","type":"text","name":"文本11","icon":"&#xe654;","formField":"text_8DAA445228DA1119","options":{"config":{"type":"input","options":[]},"defaultValue":"","description":"","required":false,"unique":false}}]}`;

export const getFormConfig = (id) => {
    return new Promise((resolve, reject) => {
        // if (id === '77f769547c5c427c920fbbe83ba0d6bf') {
        //     resolve(JSON.parse(tempFormData));
        //     return;
        // }
        get(`${API_FORM_TEMPLATE_DETAIL}/${id}`).then((result) => {
            if (result) {
                result.fieldsList = result.fieldsList.map(item => {
                    // item.fieldId = item.id;
                    return item;
                });
            }

            resolve(result);
        }).catch(err => {
            reject(err);
        });
    });
};

export const saveFormConfig = (objFormConfig) => {
    // http://39.107.229.85:13888/bcbpm/getFormList?currentPage=1&pageSize=10
    return post(API_FORM_TEMPLATE_SAVE, objFormConfig);
};
export const getCopyTreeConfig = (param) => {
    return post(API_FORM_GET_COPY_TREE_CONFIG, param);
};
export const getFormDataLinkConfig = (triggerFormId) => {
    return get(API_FORM_TEMPLATE_GETFORMDATALINKCONFIG, triggerFormId);
};
export const getCustomFormRuleConfig = (formId) => {
    return get(API_FORM_TEMPLATE_GET_CUSTOMFORMRULECONFIG, formId);
};
export const getFormDataUpdConfigBOList = (formId) => {
    return get(API_FORM_TEMPLATE_GET_FORM_DATA_AUTH_LIST, formId);
};
export const deleteFormConfig = (id) => {
    // http://39.107.229.85:13888/bcbpm/getFormList?currentPage=1&pageSize=10
    return del(`${API_FORM_TEMPLATE_DELETE}/${id}`);
};

export const getFormConfigs = (formIds) => {
    return get(API_FORM_TEMPLATE_FORMCONFIGS, { formIds });
};
export const getBIFormConfigs = (param) => {
    return get(API_FORM_TEMPLATE_BI_FORMCONFIGS, param);
};
export const getFormDashBoardData = (formId) => {
    return post(API_FORM_TEMPLATE_BI_DATA, formId);
};
export const getFormFieldStatistics = (formId) => {
    return post(API_FORM_FIELD_STATISTICS, formId);
};
export const getFormFieldStatisticsGroup = (formId) => {
    return post(API_FORM_FIELD_STATISTICSGROUP, formId);
};
export const getProgressBarList = (formId) => {
    return post(API_FORM_GETPROGRESSBARLIST, formId);
};
export const getDataProgressBarList = (formId) => {
    return post(API_FORM_GETDATAPROGRESSBARLIST, formId);
};
export const getWarehousing = (param) => {
    return get(API_FORM_TEMPLATE_WAREHOUSING, param);
};
export const getFormDashBoardConfig = (formId) => {
    return get(API_FORM_TEMPLATE_BI_CONFIG, { formId });
};
export const getFormAggregateTableConfig = (formId) => {
    return get(API_FORM_TEMPLATE_AGGREGATE_TABLE_CONFIG, { formId });
};
export const getApproveData = (formId) => {
    return get(API_FORM_APPROVE_CONFIG, { formId });
};
export const getFormFieldListByIds = (ids) => {
    return get(API_FORM_FORMFIELDS, { ids });
};
export const updateUserFormViewField = (param) => {
    return get(API_FORM_UPDATEUSERFORMVIEWFIELD, param);
};
export const saveConfigOption = (objConfig) => {
    return post(API_FORM_SELECT_OPTION_SAVE, objConfig);
};
export const saveConfigOptionList = (objConfigList) => {
    return post(API_FORM_SELECT_OPTION_LIST_SAVE, objConfigList);
};

export const saveCalculation = (param) => {
    return post(API_FORM_CALCULATION_SAVE, param);
};

export const saveSubFormSummary = (param) => {
    return post(API_FORM_SUBFORM_SUMMARY_SAVE, param);
};

export const getCustomFormDataMapingListByFormId = (param) => {
    return get(API_PROCESS_CUSTOM_FORMDATA_MAPING_LIST, param);
};

export const saveCustomFormDataMapings = (param) => {
    return post(API_PROCESS_CUSTOM_FORMDATA_MAPING_SAVE, param);
};

export const syncProcessFormData = (param) => {
    return post(API_PROCESS_CUSTOM_FORMDATA_SYNC, param);
};

export const getFormConfigHistory = (id) => {
    return new Promise((resolve, reject) => {
        get(`${API_FORM_TEMPLATE_DETAIL_HISTORY}/${id}`).then((result) => {
            if (result) {
                result.fieldsList = result.fieldsList.map(item => {
                    // item.fieldId = item.id;
                    return item;
                });
            }

            resolve(result);
        }).catch(err => {
            reject(err);
        });
    });
};

export const revertCustomForm = (formId) => {
    return post(API_FORM_TEMPLATE_REVERT_CUSTOMFORM, {formId: formId});
};

export const getFormMsgConfigBO = (formId, treeId) => {
    return get(API_CUSTOM_MSG_CONFIG_GET, {formId: formId, treeId: treeId});
};

export const saveFormMsgConfigBO = (param) => {
    return post(API_CUSTOM_MSG_CONFIG_SAVE, param);
};
export const delFormMsgConfigBO = (param) => {
    return post(API_CUSTOM_MSG_CONFIG_DELETE, param);
};
export const getFormEntry = (param) => {
    return post(API_CUSTOM_GETFORMENTRY, param);
};
export const addFormEntry = (param) => {
    return post(API_CUSTOM_ADDFORMENTRY, param);
};

export const getFormListByMainFormId = (formId) => {
    return get(API_FORM_TEMPLATE_LIST_BY_MAIN_FORMID, { formId });
};

export const getFormulaSearchList = (param) => {
    return get(API_GET_FORMULA_SEARCHLIST, param);
};

export const getModelListByMainFormId = (formId) => {
    return get(API_FORM_MODEL_LIST_BY_MAIN_FORMID, { formId });
};

export const getModelListByRefFormIds = (formIds) => {
    return get(API_FORM_MODEL_LIST_BY_REF_FORMIDS, { formIds });
};

export const getFormFieldListByFieldId = (formFieldId, type) => {
    return get(API_FORM_FIELD_LIST_BY_FIELDID, { formFieldId: formFieldId, type: type });
};

export const getCustomFormsByFiedIdType = (type) => {
    return get(API_FORMS_LIST_BY_FIELD_TYPE, {type: type});
};

export const getFieldListByMainFormFiedId = (formFieldId) => {
    return get(API_FORM_FIELD_LIST_BY_MAIN_FORM_FIELDID, {formFieldId});
};

export const getFieldListMapByMainFormFiedIds = (formFieldIds) => {
    return get(API_FORM_FIELD_LIST_MAP_BY_MAIN_FORM_FIELDIDS, {formFieldIds});
};

export const getUpMoneyFieldList = (param) => {
    return post(API_FORM_UP_MONEY_FIELD_LIST, param);
};

export const getCascadeDeptRootId = (param) => {
    return post(API_FORM_CASCADE_DEPT_ROOT_ID, param);
};

export const getFormLeftTree = (param) => {
    return get(API_MODEL_FORM_LEFT_TREE, param);
};
export const getCrossFormConfigs = (id) => {
    return get(`${API_FORM_CROSS_TEMPLATE_LIST}/${id}`);
};



// WEBPACK FOOTER //
// ./src/data-model/form-model.js